import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { DckSelectors, DckActionCreators } from "dck-redux"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import { sortDate } from "../../../lib/utils"

class ListGLClosure extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    glclosure: null,
    running: false,
    success: false,
    error: null,
  }

  componentDidMount() {
    this.props.loadData()
  }

  handleDelete = glclosure => this.setState({ 
    glclosure,
    running: false,
    success: false,
    error: null
  })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { glclosure: { id } } = this.state

    blockingFetchService(
      accessToken => apiServerApi.deleteGLClosure(accessToken, id),
      _ => {
        this.setState({ success: true })
        this.props.loadData()
        setTimeout(this.closeDeleteForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeDeleteForm = () => this.setState({ glclosure: null })

  doClearFilters = () => {
    this.refs.closingDateFormatted.cleanFiltered()
    this.refs.comments.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this item?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <Link to={`/glclosures/${id}/update`} className='p-5'>
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  render() {
    const { glclosures } = this.props,
    { glclosure, running } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='GL closures' data={ [{ url: '/accounting', title: 'Accounting' }] } />

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <SingleSelectTable
          items={ glclosures }
          addNewLabel="New Closure"
          addNewHandler={() => browserHistory.push("/glclosures/create")}
          handleDelete={ this.handleDelete }
          deleteLabel='Delete'
          disableDelete={() => false}
          shouldRenderToolbar={ this.isAdminOrAccountant }
        >
          <TableHeaderColumn
            ref='closingDateFormatted'
            dataField="closingDateFormatted"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.closingDate, b.closingDate, order)}
            filter={{ type: "DateFilter", delay: 1000 }}
            dataAlign="center"
            columnClassName="min-w-120"
          >
            Closing Date
          </TableHeaderColumn>

          <TableHeaderColumn  
            ref='comments'
            dataField="comments"
            dataSort={ true }
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            columnClassName="min-w-120"
          >
            Comments
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='createdOnFormatted'
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
            dataFormat={ cell => <small>{ cell }</small> }
            filter={{ type: "DateFilter", delay: 1000 }}
            width="140px"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            isKey={ true }
            dataField="id"
            dataAlign="center"
            width="80px"
            dataFormat={(_, row) =>
            <span className="flex-detail">
              <Link to={`/glclosures/${row.id}/detail`} className='p-5'>
                <FontAwesome name="eye" title='View' />
              </Link>
              { this.renderUpdateLink(row.id) }
            </span>
            }
          />
        </SingleSelectTable>

        <AlertModal
          show={ glclosure != null }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glclosures = DckSelectors.selectAllItems(state, ItemTypes.GLClosure)
  return { glclosures }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLClosure)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListGLClosure)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/List.js